import React from 'react';
import { presetRange } from '../../utils/oversightFormat';

/**
 * DateRangePreset — Controlled date-range selector for analytics queries
 * Emits { days, date_from, date_to } on change, where date_from/date_to come from presetRange()
 * @component
 * @param {Object} props
 * @param {number} props.value - Selected preset (7|14|30|90 days)
 * @param {function} props.onChange - Callback receiving { days, date_from, date_to }
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactElement}
 */
export function DateRangePreset({ value, onChange, className = '' }) {
  const presets = [
    { days: 7, label: 'Last 7 days' },
    { days: 14, label: 'Last 14 days' },
    { days: 30, label: 'Last 30 days' },
    { days: 90, label: 'Last 90 days' },
  ];

  const handleChange = (e) => {
    const days = parseInt(e.target.value, 10);
    const { date_from, date_to } = presetRange(days);
    onChange({ days, date_from, date_to });
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      className={`min-h-[44px] py-2 px-3 text-sm rounded-lg border border-gray-200 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-primary/30 ${className}`}
    >
      {presets.map((preset) => (
        <option key={preset.days} value={preset.days}>
          {preset.label}
        </option>
      ))}
    </select>
  );
}
